export default "/images/left-arrow.png?7d1e1f7dce2dd16f7f11ffe32439e309";